import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { ISelectOption, SetSelectOption } from "src/@types/form";
import sortIcon from "src/assets/icons/sort.svg";
import { SortOption } from "./SortOption";
import { getSortLabel } from "./constants";
import { Dropdown } from "../Dropdown";

const SORTING_ICON_ALT_TEXT = "Sort icon";

interface Props {
  className?: string;
  options: ISelectOption[];
  activeOption: ISelectOption;
  setOption: SetSelectOption;
  isStatus?: boolean;
}

export const SortingDropdownList: FC<Props> = ({
  className,
  options,
  activeOption,
  setOption,
  isStatus,
}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const isPhone = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.SM,
  });

  const sortLabel = isPhone ? "" : t(getSortLabel(isStatus));

  const sortBy = activeOption
    ? typeof activeOption.label !== "string"
      ? t(activeOption.label.i18nKey)
      : activeOption.label
    : "";

  const headDropdownLabel = (
    <div className="flex gap-2">
      <img src={sortIcon} alt={SORTING_ICON_ALT_TEXT} />
      {activeOption ? (
        <span>{`${sortLabel} ${sortBy}`}</span>
      ) : (
        <span>{sortLabel}</span>
      )}
    </div>
  );

  const filteredOptions = activeOption
    ? options.filter(({ value }) => value !== activeOption.value)
    : options;

  const setActiveOption = (option: ISelectOption) => {
    setOption(option);
    setIsOpen(false);
  };

  return (
    <Dropdown
      className={className}
      head={headDropdownLabel}
      headClassName="flex items-center gap-2 w-max py-2 px-3"
      bodyClassName="bg-white-pink px-3 min-w-[210px] w-max !left-4 !right-4 !-translate-x-0 z-10 rounded-20 shadow-light-bottom"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isActiveIndicatorArrow={false}
    >
      <ul>
        {filteredOptions.map((option) => (
          <SortOption
            key={option.id}
            option={option}
            setOption={setActiveOption}
          />
        ))}
      </ul>
    </Dropdown>
  );
};
